module.exports = __webpack_public_path__ + "img/hr-green-croton-08.feeea5a7.png";